import { render, staticRenderFns } from "./DiscipleshipGroups.vue?vue&type=template&id=11ee8925&"
import script from "./DiscipleshipGroups.vue?vue&type=script&lang=js&"
export * from "./DiscipleshipGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports